<template>
  <div>
    <div class="check-in-page">
      <div class="qr-section">
        <div
          class="qr-btn"
          @click="toCheckInProcess('qr-code')"
        >
          <img
            src="../../../assets/img/qr-code.png"
            alt=""
          >
          <br>
          <span> Tap to scan </span>
        </div>
      </div>
      <div class="action-area">
        <div class="action-area-section">
          <v-row>
            <v-col cols="12">
              <v-btn
                class="btn-style disable-btn"
                color="#64CA7F"
                elevation="0"
                :disabled="!isOrgAvailable"
                @click="openCheckinSheet = true"
              >
                <v-icon color="black">
                  mdi-account-check-outline
                </v-icon>
                <span> Check-in</span>
              </v-btn>
            </v-col>
          </v-row>
          <!-- <div class="text-center">
            <br>
            <span>OR</span>
            <v-btn
              class="btn-style"
              color="#FFCA68"
              elevation="0"
            >
              <v-icon color="black">
                mdi-currency-usd
              </v-icon>
              <span> Cost Shift </span>
            </v-btn>
          </div> -->
          <check-in-page-history />
        </div>
      </div>
    </div>
    <center-spinner :loading="loading" />
    <select-organization
      v-if="showOrganizationsList"
      @closed="showOrganizationsList = false"
      @organization-selected="toCheckInTypes"
    />
    <check-in-types
      v-if="showCheckInTypes"
      @closed="showCheckInTypes = false"
      @checkin-type-selected="continueCheckInProcess"
    />
    <qr-code-scanner
      v-if="showCheckinQrCodeScanner"
      @closed="showCheckinQrCodeScanner = false"
      @qr-code-scanned="toSelectedCheckInProcessByQRScan"
    />
    <select-project
      v-if="showOrganizationProjects"
      @closed="showOrganizationProjects = false"
      @project-selected="toProjectGatesList"
    />
    <select-project-gate
      v-if="showProjectGates"
      @closed="showProjectGates = false"
      @project-gate-selected="toSelectedCheckInProcessByManual"
    />
    <check-in-sheet
      v-if="openCheckinSheet"
      :location-enable-check="locationEnableCheck"
      :check-in-type="'manual'"
      @closed="openCheckinSheet = false"
    />
    <check-in-sheet-qr
      v-if="openQrCheckinSheet"
      :gate="gateId"
      :qr-type="qrType"
      :location-enable-check="locationEnableCheck"
      @closed="openQrCheckinSheet = false"
    />
  </div>
</template>

<script>
import QrCodeScanner from '../../process/QrCodeScanner.vue';
import spinner from '../../components/SpinnerCentre.vue';
import Constants from 'src/constants';
import SelectOrganization from 'src/views/dashboard/Components/dialogComponents/SelectOrganization';
import CheckInTypes from 'src/views/dashboard/Components/CheckInTypes';
import SelectProject from 'src/views/dashboard/Components/dialogComponents/SelectProject';
import SelectProjectGate from 'src/views/dashboard/Components/dialogComponents/SelectProjectGate';
import CheckInPageHistory from '../Components/CheckInPageHistory.vue';
import CheckInSheet from './CheckInSheet.vue';
import CheckInSheetQr from './CheckInSheetQr.vue';

export default {
  name: 'CheckInCheckOutPage',
  components: {
    'qr-code-scanner': QrCodeScanner,
    'center-spinner': spinner,
    'select-organization': SelectOrganization,
    'check-in-types': CheckInTypes,
    'select-project': SelectProject,
    'select-project-gate': SelectProjectGate,
    'check-in-page-history': CheckInPageHistory,
    'check-in-sheet': CheckInSheet,
    'check-in-sheet-qr': CheckInSheetQr,
  },
  data: () => ({
    loading: false,
    selectedCheckInType: null,
    userDetails: {},
    showCheckinQrCodeScanner: false,
    showOrganizationsList: false,
    checkInMethodType: null,
    showOrganizationProjects: false,
    showProjectGates: false,
    showCheckInTypes: false,
    openCheckinSheet: false,
    openQrCheckinSheet: false,
    gateId: null,
    qrType: null,
  }),
  computed: {
    userOrganizations () {
      return this.$store.getters['organization/getUserOrganizations'];
    },
    selectedOrgProjectGate () {
      return this.$store.getters['projects/getSelectedOrgProjectGate'];
    },
    isOrgAvailable () {
      if (
        this.selectedOrganization !== null &&
        this.selectedOrganization !== undefined
      ) {
        return true;
      }
      return false;
    },
    activeCheckInDetails () {
      return this.$store.getters['swiftuser/getActiveCheckInDetails'];
    },
    isActiveCheckInDetailsFetched () {
      if (Object.keys(this.activeCheckInDetails).length > 0) {
        return true;
      }
      return false;
    },
    selectedOrganization () {
      return this.$store.getters.getSelectedOrganization;
    },
    orgSettings () {
      return this.$store.getters['organization/getOrganizationSettings'];
    },
    locationEnableCheck () {
      return this.orgSettings.location_verification;
    },
  },
  async mounted () {
    await this.loadOnMount();
    (await this.isOrgAvailable) && (await this.fetchOrgDetails());
    this.getUserOrganizations();
    this.checkQrScanTime();
    this.$store.dispatch('projects/clearGateDetails');
  },
  methods: {
    checkQrScanTime () {
      const scannedTime = localStorage.getItem('scannedTime');
      if (scannedTime === null) {
        return;
      }
      const currentTime = new Date().getTime();
      if (currentTime - scannedTime >= 300000) {
        localStorage.removeItem('siteId');
        localStorage.removeItem('scannedTime');
      }
    },
    async fetchOrgDetails () {
      await this.$store.dispatch(
        'organization/fetchOrganizationSettings',
        this.selectedOrganization,
      );
    },
    loadOnMount () {
      if (this.isActiveCheckInDetailsFetched === false) {
        return;
      }
      this.$router.push({ name: 'HomePage' });
    },
    async getUserOrganizations () {
      this.loading = true;
      await this.$store
        .dispatch('organization/fetchUserOrganizations', {
          params: {
            requestStatus: 'accepted',
          },
        })
        .catch(() => {
          this.loading = false;
        });
      this.loading = false;
    },
    toCheckInProcess (type) {
      this.loading = true;
      this.checkInMethodType = type;
      if (this.userOrganizations.length > 0) {
        this.loading = true;
        this.$store.dispatch(
          'organization/selectedOrganization',
          this.selectedOrganization,
        );
        this.loading = false;
        this.toCheckInTypes();
      } else {
        this.$store.dispatch(
          'alert/onAlert',
          {
            message: 'You are not under any organizations.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        this.loading = false;
        this.$router.push({ name: 'Organizations' });
      }
    },
    toCheckInTypes () {
      if (this.selectedOrganization.types.length === 1) {
        this.showOrganizationsList = false;
        this.continueCheckInProcess(this.selectedOrganization.types[0]);
      } else {
        this.showOrganizationsList = false;
        this.showCheckInTypes = true;
      }
    },
    continueCheckInProcess (type) {
      this.showOrganizationsList = false;
      this.showCheckInTypes = false;
      this.selectedCheckInType = type;
      if (this.checkInMethodType === 'manual') {
        this.$store.dispatch('swiftuser/storeCheckInMethodType', {
          type: 'manual-checkin',
        });
        this.loading = false;
        this.showOrganizationProjects = true;
      } else {
        this.$store.dispatch('swiftuser/storeCheckInMethodType', {
          type: 'qr-code-checkin',
        });
        this.loading = false;
        this.openQrCodeScanner();
      }
    },
    toProjectGatesList () {
      this.showOrganizationsList = false;
      this.showCheckInTypes = false;
      this.showOrganizationProjects = false;
      this.showProjectGates = true;
    },
    toSelectedCheckInProcessByManual () {
      this.loading = true;
      this.showOrganizationsList = false;
      this.showCheckInTypes = false;
      this.showOrganizationProjects = false;
      this.showProjectGates = false;
      const type = this.selectedCheckInType;
      const siteId = this.selectedOrgProjectGate.id;
      this.$router.push(`check-in/${siteId}/${type}`);
    },
    openQrCodeScanner () {
      this.loading = true;
      this.checkQrScanTime();
      const siteId = localStorage.getItem('siteId');
      if (siteId !== null) {
        this.toSelectedCheckInProcessByQRScan(siteId);
        this.loading = false;
        return;
      }
      setTimeout(() => {
        this.showCheckinQrCodeScanner = true;
        this.loading = false;
      }, 1000);
    },
    toSelectedCheckInProcessByQRScan (id) {
      if (id.length === 0 || id === 'undefined') {
        this.$store.dispatch(
          'alert/onAlert',
          {
            message: 'Unauthorized QR-Code',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        localStorage.removeItem('siteId');
        return;
      }
      this.showOrganizationsList = false;
      this.showCheckInTypes = false;
      this.showCheckinQrCodeScanner = false;
      this.gateId = id;
      this.qrType = this.selectedCheckInType;
      this.openQrCheckinSheet = true;
    },
  },
};
</script>
<style scoped>
.check-in-page {
  position: relative;
  height: 100vh;
}

.qr-section {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  height: 50%;
  width: 100%;
}

.action-area {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 50%;
  background: #F5F5FF;
  overflow-y: scroll;
}

.action-area-section {
  padding: 20px 20px 20px 20px;
}

.qr-btn {
  height: auto !important;
  text-align: center;
}

.disable-btn.v-btn.v-btn--disabled {
  background-color: #d6d6d6 !important;
  opacity: 0.5 !important;
  cursor: not-allowed !important;
}

.disable-btn.v-btn.v-btn--disabled .v-icon {
  color: #000000 !important;
}
</style>
